interface Props {
  image: string
  alt: string
  href: string
}

const ImageWrapper = ({ image, alt, href }: Props) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="w-full block"
    >
      <img
        src={image}
        alt={alt}
        onError={(e) => {
          if (e.currentTarget.src !== '/assets/images/lab.webp') {
            e.currentTarget.src = '/assets/images/lab.webp'
          }
        }}
        loading="lazy"
        data-testid="img-wrapper"
        className="aspect-[3/2]"
      />
    </a>
  )
}

export default ImageWrapper
